import byPageMaker from 'reducersMakers/byPageMaker';
import * as actions from 'actions';

export default byPageMaker([actions.JOURNAL_ENTRIES_FETCH_SUCCESS], 'journalEntriesIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/byPage/reducer.js
 **/